import { useQuery } from '@tanstack/react-query';
import {
  fetchOwnershipNetwork,
  type OwnershipNetworkQuery,
  type OwnershipNetworkResponse,
} from './client.js';

// Ownership Network (multi-group explorer) hook. Keyed on the full query
// (country + subsegment + minOpcos), so changing a filter refetches.

export function useOwnershipNetwork(query: OwnershipNetworkQuery = {}) {
  return useQuery<OwnershipNetworkResponse, Error>({
    queryKey: ['ownership-network', query] as const,
    queryFn: () => fetchOwnershipNetwork(query),
    staleTime: 5 * 60_000,
  });
}
